jQuery(document).ready(function ($) {

  $('.blocks--contact-form').on('click', '.submit-form', function () {
    var btn = $(this);
    var currentContentClass = $('.blocks--contact-form');
    var currentSuccessClass = $('.contact-form-success');
    var redirectUrl = $('#redirect').val();

    btn.text('Sending question');

    $.ajax({
      url : contact_params.ajaxurl,
      data : {
        'action' : 'submit',
        'contact_name'           : $('#input-name').val(),
        'contact_email_address'  : $('#input-email').val(),
        'contact_number'         : $('#input-number').val(),
        'contact_enquiry'        : $('#input-enquiry').val(),
        'contact_page_id'        : $('#input-page-id').val(),
        'contact_page_recaptcha' : $('#input-recaptcha').val(),
      },
      type : 'POST',
      dataType: 'json',
      success: function (response) {
        if ( response.success === false ) {
          if ( currentSuccessClass.length ) {
            currentSuccessClass.fadeOut('slow');
          }
          if ( response.data.contact_name ) {
            currentContentClass.find('.contact-name').fadeOut().text(response.data.contact_name[0]).fadeIn();
          } else {
            currentContentClass.find('.contact-name').fadeOut();
          }
          if ( response.data.contact_email_address ) {
            currentContentClass.find('.contact-email-address').fadeOut().text(response.data.contact_email_address[0]).fadeIn();
          } else {
            currentContentClass.find('.contact-email-address').fadeOut();
          }
          if ( response.data.contact_number ) {
            currentContentClass.find('.contact-number').fadeOut().text(response.data.contact_number[0]).fadeIn();
          } else {
            currentContentClass.find('.contact-number').fadeOut();
          }
          if ( response.data.contact_enquiry ) {
            currentContentClass.find('.contact-enquiry').fadeOut().text(response.data.contact_enquiry[0]).fadeIn();
          } else {
            currentContentClass.find('.contact-enquiry').fadeOut();
          }
          if ( response.data.contact_is_spam ) {
            currentContentClass.find('.contact-is-spam').fadeOut().text(response.data.contact_is_spam[0]).fadeIn();
          } else {
            currentContentClass.find('.contact-is-spam').fadeOut();
          }
          btn.text('Send my question');
        } else {
          btn.text('Send my question');
          if (redirectUrl.length) {
            window.location.replace(redirectUrl);
          } else {
            currentContentClass.find('.contact-name').fadeOut();
            currentContentClass.find('.contact-email-address').fadeOut();
            currentContentClass.find('.contact-number').fadeOut();
            currentContentClass.find('.contact-enquiry').fadeOut();
            currentContentClass.find('.contact-is-spam').fadeOut();

            if ( currentSuccessClass.length ) {
              currentSuccessClass.fadeOut('slow');
            }

            $('#input-name').val('');
            $('#input-email').val('');
            $('#input-number').val('');
            $('#input-enquiry').val('');
            $('#recaptchaResponse').val('');

            currentSuccessClass.fadeIn('slow');
          }

        }
      }
    });
  });
});